import { useEffect,useRef } from "react";
import Lottie from "lottie-react";



function ChatWaveform({ waveformData, playing, axiSpeaking }) {
	const lottieRef = useRef( null );
	useEffect(() => {
		// if( systemStatus === 'playing' ) {
		if( playing === true || axiSpeaking === true) {
			lottieRef.current.play();
		} else {
			lottieRef.current.pause();
		}
	},[playing]);

	return <Lottie lottieRef={lottieRef} animationData={waveformData} loop={true} />;
}

export default ChatWaveform;